import http from './http'

// 获取仪器列表
export const getInstrumentList = data => {
    return http('/admin-api/jyjc/deploy-instrument/getAppDeployInstrumentList', 'get', data)
}
// 返回箱号 获取对应箱号列表
export const getinstrumentBoxList = data => {
    return http('/admin-api/jyjc/deploy-instrument/getAppInstrumentListByBox?instrumentBox=' + data.instrumentBox, 'get', data)
}


// 登录获取tokend
export const getTOKEN = data => {
    return http('/app-api/member/auth/login', 'post', data)
}

// 登录获取tokend
export const getTenantNameById = data => {
    return http('/app-api/member/tenant/get-name-by-id', 'post', data)
}

// 获取动态信息/inspection/deploy-active-contents/getActiveContentsListForApp
export const getActiveContentsList = data => {
    return http(`/admin-api/inspection/deploy-active-contents/getActiveContentsListForApp?infoId=${data.infoId}`, 'get', data)
}

// 发布页获取动态信息
export const getsetactiveByInfoIdodd = data => {
    return http(`/app-api/inspection/info-active-contents/get-set-activeByInfoId-odd?id=${data.id}`, 'get', data)
}
// // 记录详情数据
// export const getProblemListForApp = data => {
//   return http(`/admin-api/inspection/deploy-problem/getProblemListForApp?infoId=${data.infoId}`, 'get', data)
// }
// 记录详情数据
export const getProblemListForApp = data => {
    return http(`/app-api/inspection/info-problem/get-set-problemList-odd?id=${data.id}`, 'get', data)
}

//委托单位
export const clientData = data => {
    return http(`/admin-api/inspection/uni-manage/list-all-simple?filedName=${data.filedName}&uniConfigId=${data.uniConfigId}`, 'get', data)
}



// 返回记录详情数据
export const DetectionProblemRecord = data => {
    return http('/app-api/inspection/info-problem/createInfoProblemList', 'post', data)
}

// 批量更新记录详情数据
export const updateInfoProblemList = data => {
    return http('/app-api/inspection/info-problem/updateInfoProblemList', 'post', data)
}


// 获取所有字典信息
export const listSimpleDictDatas = data => {
    return http('/admin-api/system/dict-data/list-all-simple', 'get', data)
}


// 获取工程概况
// const getDeployListForAppAxios = new Service("/admin-api/inspection/deploy/getDeployListForApp")
// export const getDeployListForApp = data => {
//   return getDeployListForAppAxios.get(data)
// }
export const getDeployListForApp = data => {
    return http('/admin-api/inspection/deploy/getDeployListForApp?deviceType=' + data.deviceType, 'get', data)
}

// 下一步传数据给后端保存
export const giveCreate = data => {
    return http('/admin-api/inspection/info/create', 'post', data)
}
//更新检验检测主表单
export const update = data => {
    return http('/app-api/inspection/info/update', 'put', data)
}

// 检验检测已处理数据
export const getInfoListForApp = data => {
    return http('/app-api/inspection/info/getInfoListForApp', 'get', data)
}

//获取记录详情只读数据
export const getProblemListById = data => {
    return http(`/app-api/inspection/info-problem/getProblemListById?id=${data.id}`, 'get', data)
}

//检验检测设备概况设备详情类型列表
export const config_columns_list = data => {
    return http(`/app-api/app/inspection-equ/config-columns-list`, 'get', data)
}
//检验检测设备概况设备详情值
export const get_equipment = data => {
    return http(`/app-api/app/inspection-equ/get-equipment?id=${data.id}`, 'get', data)
}



//工程概况下拉选列表
export const projectname = data => {
    return http(`/app-api/app/inspection-prj/page-project?pageNo=${data.pageNo}&pageSize=${data.pageSize}&prjConfigId=${data.prjConfigId}`, 'get', data)
}
//检验检测发布只读页面前三页数据
export const deploy = data => {
    return http(`/app-api/inspection/info/get?id=${data.id}`, 'get', data)
}


export const getMemberlist = data => {
    return http(`/app-api/app/inspection-flow/getCandidates`, 'get', data, true)
}

// 检验检测发布页面签名
export const getfaceID = data => {
    return http(`/app-api/inspection/user-sign/create`, 'post', data)
}

//    流程

// 新增历史记录
export const InspectionPublish = data => {
    return http(`/app-api/inspection/info-result-history/create`, 'post', data)
}
// 修改历史记录
export const updateInspectionPublish = data => {
    return http(`/app-api/inspection/info-result-history/update`, 'put', data)
}

// 检验检测流程状态
export const updateFlowStatus = data => {
    return http(`/app-api/inspection/info/updateFlowStatus`, 'put', data)
}
// 发起流程

export const createProcessInstance = data => {
    // return http(`/app-api/app/flow/createProcessInstance?infoId=1` + `&processDefinitionId=` + data.processDefinitionId, 'post', data)
    return http(`/app-api/app/flow/createProcessInstance`, 'post', data)
}

// 提交审核
export const chooseAndSetAssignee = data => {
    return http(`/app-api/app/inspection-flow/createInspectionFlow`, 'post', data)
}

export const inspectionFlowExamine = data => {
    return http(`/app-api/app/inspection-flow/inspectionFlowExamine`, 'post', data)
}


// 获取Todo待办
export const getTodoPage = data => {
    return http(`/app-api/app/flow/task-todo-page?pageNo=${data.pageNo}&pageSize=${data.pageSize}`, 'get', data)
}

// 通过任务
export const taskApprove = data => {
    return http(`/app-api/app/flow/task-approve`, 'put', data)
}


export const inspectionFlowSign = data => {
    return http(`/app-api/app/inspection-flow/inspectionFlowSign`, 'post', data)
}


// 获取用户权限信息
export const getUserRoot = data => {
    return http(`/app-api/member/user/get`, 'get', data)
}
// 驳回
export const taskRejectBack = data => {
    return http(`/app-api/app/flow/task-reject-back`, 'post', data)
}
// 检验检测发布动态信息上传

export const createInfoActiveContentsBatch = data => {
    return http(`/app-api/inspection/info-active-contents/createInfoActiveContentsBatch`, 'post', data)
}

//获取只读动态信息数据

export const getInfoActiveByInfoId = data => {
    return http(`/app-api/inspection/info-active-contents/getInfoActiveByInfoId?id=${data.infoId}`, 'get', data)
}

//只读页面工程名称信息
export const get_project = data => {
    return http(`/app-api/app/inspection-prj/get-project?id=${data.id}`, 'get', data)
}
//设备概况安装位置数据
export const list_all_simple = data => {
    return http(`/app-api/app/inspection-equ/page-equipment?equConfigId=${data.equConfigId}&pageNo=${data.pageNo}&pageSize=${data.pageSize}`, 'get', data)
}
//设备概况安装位置数据
export const list_all_simple_queryStr = data => {
    return http(`/app-api/app/inspection-equ/page-equipment?equConfigId=${data.equConfigId}&pageNo=${data.pageNo}&pageSize=${data.pageSize}&queryStr=${data.queryStr}`, 'get', data)
}
// 检验检测已处理
export const task_done_page = data => {
    return http(`/app-api/app/flow/task-done-page?pageNo=${data.pageNo}&pageSize=${data.pageSize}`, 'get', data)
}
//根据infoid判断用户是否需要签名
export const getRoleByInfoId = data => {
    return http(`/app-api/inspection/user-sign/getRoleByInfoId?infoId=${data.infoId}`, 'get', data)
}
//只读页面数据上传
export const createProblemHandleHistoryBatch = data => {
    return http(`/app-api/inspection/info-problem-handle-history/createProblemHandleHistoryBatch`, 'post', data)
}

// 获取用户信息
export const getUserData = data => {
    return http(`/app-api/member/user/get`, 'get', data)
}
//批量更新检验检测动态信息登记
export const updateInfoActiveContentsBatch = data => {
    return http(`/app-api/inspection/info-active-contents/updateInfoActiveContentsBatch`, 'post', data)
}
//批量更新检验检测动态信息登记
export const updateInfoActiveContent = data => {
    return http(`/app-api/inspection/info-active-contents/update-active-content`, 'post', data)
}

// 生成文档列表

export const getReportById = data => {
    return http(`/admin-api/inspection/deploy-report/getReportById?infoId=` + data.infoId, 'get', data)
}
// 生成文档

export const insertExportByInfoId = data => {
    return http(`/admin-api/inspection/deploy-report/insertExportBatchByInfoId`, 'post', data)
}

// 生成文档列表盖章调取
export const setFileSeal = data => {
    return http(`/admin-api/inspection/export-report/setFileSeal?id=` + data.id, 'post', data)
}

// 生成文档列表已盖章
export const getExportReportListSealExist = data => {
    return http(`/admin-api/inspection/export-report/getExportReportListSealExist?infoId=` + data.infoId, 'get', data)
}

// 生成文档列表未盖章
export const getExportReportListByInfoId = data => {
    return http(`/admin-api/inspection/export-report/getExportReportListSealNonExist?infoId=` + data.infoId, 'get', data)
}

//我发起数据
export const process_my_page = data => {
    return http(`/app-api/app/flow/process-my-page?pageNo=${data.pageNo}&pageSize=${data.pageSize}`, 'get', data)
}
//驳回弹窗
export const getHistoryLastByInfoId = data => {
    return http(`/app-api/inspection/info-result-history/getHistoryLastByInfoId?infoId=${data.infoId}`, 'get', data)
}
//用户隐私协议内容
export const getNotifyByInfoId = data => {
    return http(`/admin-api/inspection/deploy-notify/getNotifyByInfoId?infoId=${data.infoId}`, 'get', data)
}

//通过签名id获取签名照片
export const getSignImg = data => {
    return http(`/app-api/inspection/user-sign/get?id=` + data.id, 'get', data)
}

//通过签名id获取签名照片
export const getFaceImg = data => {
    return http(`/app-api/inspection/user-sign/getFaceById?id=` + data.id, 'get', data)
}


//获取检验保证项数据
export const getResultCount = data => {
    return http(`/app-api/inspection/info-problem/getResultCount?infoId=${data.infoId}`, 'get', data)
}

export const getInspectionInfo = data => {
    return http(`/admin-api/inspection/info/get?id=${data.id}`, 'get', data)
}

export const getProblemHandleHistoryBatch = data => {   //二级审核接收一级审核 审核数据(暂时没用上)
    return http(`/app-api/inspection/info-problem-handle-history/getProblemHandleHistoryBatch?infoId=${data.infoId}`, 'get', data)
}
export const getProblemHandleHistoryByInfoId = data => {   //二级审核接收一级审核 审核数据(暂时没用上)
    return http(`/app-api/inspection/info-problem-handle-history/getProblemHandleHistoryByInfoId?infoId=${data.infoId}`, 'get', data)
}
// 查看审批记录 已处理 我发起页面
export const getAllHistoryByInfoId = data => {
    return http(`/app-api/inspection/info-result-history/getAllHistoryByInfoId?infoId=${data.infoId}`, 'get', data)
}
// 查看流程 审批记录 HistoryList 页面
export const getHistoryListByInfoId = data => {
    return http(`/app-api/inspection/info-result-history/getHistoryListByInfoId?infoId=${data.infoId}`, 'get', data)
}

//  检验检测接口（第二版本）
// 1.获取待处理
export const getInfoTodoForApp = data => {
    return http(`/app-api/inspection/info/getInfoTodoForApp?deviceType=${data.deviceType}`, 'get', data)
}
//2.获取已处理
export const getInfoDoneForApp = data => {
    return http(`/app-api/inspection/info/getInfoDoneForApp?pageNo=${data.pageNo}&pageSize=${data.pageSize}&deviceType=${data.deviceType}&projectName=${data.projectName}&reportNumber=${data.reportNumber}&beginFlowCreateTime=${data.beginFlowCreateTime}&endFlowCreateTime=${data.endFlowCreateTime}&flowId=${data.flowId}&deployName=${data.deployName}`, 'get', data)
}
//3.获取我发起
export const getInfoCreateForApp = data => {
    return http(`/app-api/inspection/info/getInfoCreateForApp?pageNo=${data.pageNo}&pageSize=${data.pageSize}&deviceType=${data.deviceType}&projectName=${data.projectName}&reportNumber=${data.reportNumber}&beginFlowCreateTime=${data.beginFlowCreateTime}&endFlowCreateTime=${data.endFlowCreateTime}&flowId=${data.flowId}&deployName=${data.deployName}`, 'get', data)
}
//4.获取我管理
export const getInfoManageForApp = data => {
    return http(`/app-api/inspection/info/getInfopageForApp?pageNo=${data.pageNo}&pageSize=${data.pageSize}&deviceType=${data.deviceType}&projectName=${data.projectName}&reportNumber=${data.reportNumber}&synMemName=${data.synMemName}&beginFlowCreateTime=${data.beginFlowCreateTime}&endFlowCreateTime=${data.endFlowCreateTime}&flowId=${data.flowId}&deployName=${data.deployName}`, 'get', data)
}
// 获取用户权限 去判断待处理 发布的加号 +
export const getUserForApp = data => {
    return http(`/admin-api/member/user/getUserForApp`, 'get', data)
}
// 通过infoId 获取 processInstanceId 在 草稿时  编辑再次发布需要的数据
export const getDeployByInfoId = data => {
    return http(`/app-api/inspection/deploy/getDeployByInfoId?infoId=${data.infoId}`, 'get', data)
}

// 通过infoId 获取 processInstanceId 在 草稿时  编辑再次发布需要的数据
export const createRecheck = data => {
    return http(`/app-api/inspection/recheck-info/create`, 'post', data)
}

// 通过infoId 获取 processInstanceId 在 草稿时  编辑再次发布需要的数据
export const getInstallationsite = data => {
    return http(`/app-api/inspection/info/getInstallationsite?infoId=${data.infoId}&pageNo=1&pageSize=100`, 'get', data)
}

// 检验检测页面 待处理草稿中的长按删除接口
export const draftDelete = data => {
    return http(`/app-api/inspection/info/delete?id=${data.id}`, 'delete', data)
}

// 获取或创建动态信息a
export const getSetActiveByInfoId = data => {
    return http(`/app-api/inspection/info-active-contents/get-set-activeByInfoId?id=${data.id}`, 'get', data)
}

// 获取或创建记录详情
export const getSetProblemList = data => {
    return http(`/app-api/inspection/info-problem/get-set-problemList?id=${data.id}`, 'get', data)
}

// 设备 根据出厂编号 备案编号 查询信息
export const equSeleteNumber = data => {
    return http(`/app-api/app/inspection-equ/page-equipment?queryStr=${data.queryStr}&equConfigId=${data.equConfigId}&pageNo=1&pageSize=100`, 'get', data)
    // return http(`/app-api/app/inspection-equ/page-equipment?equConfigId=${data.equConfigId}&pageNo=${data.pageNo}&pageSize=${data.pageSize}&queryStr=${data.queryStr}`, 'get', data)

}

//复检设备概况，设备详情的值
export const getDeviceDetail = data => {
    return http(`/app-api/inspection/info/getDeviceDetail?infoId=${data.id}`, 'get', data)
}
// 复检上传数据
export const recheckUpdate = data => {
    return http(`/app-api/inspection/recheck-info/update`, 'post', data)
}

// 复检发布数据
export const recheckGet = data => {
    return http(`/app-api/inspection/recheck-info/get?id=${data.id}`, 'get', data)
}
// 发布复检动态信息
export const getSetActiveByInfoIdRecheckId = data => {
    return http(`/app-api/inspection/info-active-contents/get-set-activeByInfoId-recheckId?id=${data.id}`, 'get', data)
}

//复检记录详情
export const getSetProblemListRecheckexport = data => {
    return http(`/app-api/inspection/info-problem/get-set-problemList-recheck?id=${data.id}`, 'get', data)
}

// 流转新接口
export const nextFlowManage = data => {
    return http(`/app-api/inspection/info/nextFlowManage`, 'post', data)
}

// 保存草稿历史记录
export const saveDraftsHistory = data => {
    return http(`/app-api/inspection/info-result-history/createDraft`, 'post', data)
}

// 获取保存草稿历史记录
export const getSaveDraftsHistory = data => {
    return http(`/app-api/inspection/info-result-history/getDraftHistory?infoId=${data.infoId}`, 'get', data)
}

// 补充人脸签名上传
export const replenishFaceSign = data => {
    return http(`/app-api/inspection/syn-member/update`, 'post', data)
}


// 整改页上传视频文档图片
export const upcreatedocumentfrom = data => {
    return http(`/app-api/inspection/problem-rectify/create`, 'post', data)
}


// 整改页获取视频文档图片
export const getcreatedocumentfrom = data => {
    return http(`/app-api/inspection/problem-rectify/get`, 'get', data, true)
}

// 整改页获取视频文档图片
export const copyInfo = data => {
    return http(`/app-api/inspection/info/copyInfo`, 'put', data, true)
}

export const getInsDeployListForApp = data => {
    return http(`/app-api/info/rule-permission/getDeployListForApp?deviceType=${data.deviceType}&projectId=${data.projectId}&module=inspection`, 'get', data)
}

export const getInsMemberlist = data => {
    return http(`/app-api/info/rule-permission/getInsMemberUsers?ruleId=${data.ruleId}&roleCode=${data.roleCode}&module=inspection`, 'get', true)
}

export const getInsMemberByInfoIdFlowStatus = data => {
    return http(`/app-api/info/rule-permission/getInsMemberByInfoIdFlowStatus?infoId=${data.infoId}&flowStatus=${data.flowStatus}`, 'get', true)
}

